// extracted by mini-css-extract-plugin
module.exports = {"image":"da51a739f7--image--Yej9e"};